import { Injectable, signal } from '@angular/core';
import { NotificationService, NotificationDto } from './notification.service';

/**
 * Service to manage notification state, polling, and unread status.
 * Centralizes notification logic that was previously in ToolbarComponent.
 */
@Injectable({ providedIn: 'root' })
export class NotificationStateService {
  // Signals for reactive state
  notifications = signal<NotificationDto[]>([]);
  hasUnreadNotifications = signal<boolean>(false);
  isLoading = signal<boolean>(false);

  private pollingInterval?: ReturnType<typeof setInterval>;
  private readonly POLLING_INTERVAL_MS = 30000; // 30 seconds for testing

  constructor(private notificationService: NotificationService) {}

  /**
   * Starts polling for new notifications every 30 seconds.
   */

  /* startPolling(): void {
    // Load initial notifications
    this.loadNotifications();

    // Set up polling
    this.pollingInterval = setInterval(() => {
      this.checkForNewNotifications();
    }, this.POLLING_INTERVAL_MS);
  } */

  /**
   * Stops the notification polling.
   */

  /*  stopPolling(): void {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = undefined;
    }
  } */

  /**
   * Loads notifications and updates the signal.
   */
  loadNotifications(): void {
    this.isLoading.set(true);
    this.notificationService.getNotifications('NEW', 20, 1).subscribe({
      next: (items: NotificationDto[]) => {
        this.notifications.set(items);
        this.isLoading.set(false);
      },
      error: () => {
        this.isLoading.set(false);
      },
    });
  }

  /**
   * Checks for new notifications and updates unread status.
   * Only sets hasUnreadNotifications if there's at least one with status "NEW".
   */
  checkForNewNotifications(): void {
    this.notificationService.getNotifications('NEW', 20, 1).subscribe({
      next: (items: NotificationDto[]) => {
        // Only show unread icon if there's at least one notification with status "NEW"
        const hasNewNotifications = items.some((item) => item.notification_status === 'NEW');
        this.hasUnreadNotifications.set(hasNewNotifications);
      },
      error: () => {
        // Silently fail - don't update state on error
      },
    });
  }

  /**
   * Marks all notifications as read (clears unread state).
   */
  clearUnreadState(): void {
    this.hasUnreadNotifications.set(false);
  }

  /**
   * Marks a specific notification as read via the API.
   */
  markAsRead(notificationId: number): void {
    this.notificationService.markAsRead(notificationId).subscribe({
      next: () => {
        // Notification marked successfully
      },
      error: () => {
        // Failed to mark as read - could log or handle error
      },
    });
  }

  /*  ngOnDestroy(): void {
    this.stopPolling();
  } */
}
